import { render, staticRenderFns } from "./AddCouponPool.vue?vue&type=template&id=bfa96376"
import script from "./AddCouponPool.vue?vue&type=script&lang=js"
export * from "./AddCouponPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports